import * as moment from "moment";

import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild, } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import {
  AutocompleteComponent,
  AutocompleteLoadingModeType,
  DatepickerDayComponent,
  IAutocompleteSchema,
  IDatepickerSchema,
  ToastService,
  indicate
} from "maps-angular-components";
import { BehaviorSubject, Subject, Subscription } from "rxjs";

import { DatePipe } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { PaginationComponent } from "ngx-bootstrap/pagination";
import { FuncaoApi } from "src/app/funcao/api/funcao.api";
import { Funcao } from "src/app/funcao/models/funcao";
import { BrowserSupport } from "../../shared/util/browser-support";
import { Regra } from "../regra";
import { RegraService } from "../regra.service";
import { ModalDeletarRegraDialogComponent } from "./modal-deletar-regra/modal-deletar-regra.component";
import { ModalEditarRegraDialogComponent } from "./modal-editar-regra/modal-editar-regra.component";

@Component({
  selector: "gerenciador-registro",
  templateUrl: "./gerenciador-registro.component.html",
  styleUrls: ["./gerenciador-registro.component.scss"],
})
export class GerenciadorRegistroComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  @Input() composta = false;

  @ViewChild("gerenciadorRegistroRegra", {static: false}) gerenciadorRegistroRegra: AutocompleteComponent<Regra>;
  @ViewChild("gerenciadorRegistroFuncao", {static: false}) gerenciadorRegistroFuncao: AutocompleteComponent<Funcao>;
  @ViewChild("gerenciadorRegistroDataInicio", {static: false}) gerenciadorRegistroDataInicio: DatepickerDayComponent;
  @ViewChild("gerenciadorRegistroDataFim", {static: false}) gerenciadorRegistroDataFim: DatepickerDayComponent;

  form: FormGroup;

  regras: Regra[];
  regraEdicao: Regra;
  regraOriginal: Regra;

  public loading$ = new Subject<boolean>();
  loadingExport$: Subject<boolean> = new Subject<boolean>();
  showExecutar = false;

  paginationTotalPage = 1;

  totalRegistros = 0;

  totalPages: number;
  public currentPage: BehaviorSubject<number> = new BehaviorSubject<number>(1);
  private pageSize = 20;
  private allElements: Regra[] = [];
  private totalElements: number;
  dataSource: Regra[];
  private paginatedDataSource: Regra[][];
  funcaoSchema: IAutocompleteSchema<Funcao>;
  regraSchema: IAutocompleteSchema<Regra>;

  public dataInicioSchema: IDatepickerSchema;
  public dataFimSchema: IDatepickerSchema;

  @ViewChild("pagination", {static: false}) pagination: PaginationComponent;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly service: RegraService,
    private readonly funcaoService: FuncaoApi,
    private readonly dialog: MatDialog,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly messageService: ToastService,
    private readonly datePipe: DatePipe
  ) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      id: new FormControl(),
      inicioVigencia: new FormControl(),
      fimVigencia: new FormControl(),
      funcao: new FormControl(),
      page: new FormControl(0),
    });
    this.regraSchema = {
      service: this.service,
      endpoint: (this.composta) ? "autocomplete/compostas" : "autocomplete/simples",
      label: (this.composta) ? "Regra (Regra composta)" : "Regra (Regra simples)",
      placeholder: "Regra selecionada",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      formGroup: this.form,
      formControlName: "id",
      panelClass: "w-100",
      parseSearchParam(search): string {
        return search;
      },
    };
    this.funcaoSchema = {
      service: this.funcaoService,
      label: "Função",
      placeholder: "Função selecionada",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      formGroup: this.form,
      formControlName: "funcao",
      panelClass: "w-100",
      parseSearchParam(search): string {
        return search;
      },
    };
    this.dataInicioSchema = {
      label: "Data início vigência",
      placeholder: "Selecione uma data",
      formGroup: this.form,
      panelClass: 'w-100',
      formControlName: "inicioVigencia",
    };

    this.dataFimSchema = {
      label: "Data fim vigência",
      placeholder: "Selecione uma data",
      formGroup: this.form,
      panelClass: 'w-100',
      formControlName: "fimVigencia",
    };
  }

  limparForm() {
    this.regras = [];
    this.paginationTotalPage = 1;
    this.totalRegistros = 0;
    this.totalPages = 1;
    this.pageSize = 20;
    this.allElements = [];
    this.totalElements = 0;
    this.gerenciadorRegistroFuncao?.reset();
    this.gerenciadorRegistroRegra?.reset();
    this.gerenciadorRegistroDataInicio?.reset();
    this.gerenciadorRegistroDataFim?.reset();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  setModoEdicao(a) {
    this.regraOriginal = a ? {...a} : null;
    this.regraEdicao = a ? {
      ...a,
      inicioVigencia: this.datePipe.transform(a.inicioVigencia, 'dd/MM/yyyy'),
      fimVigencia: this.datePipe.transform(a.fimVigencia, 'dd/MM/yyyy')
    } : null;
  }

  regraIsEqual(a: Regra, b: Regra): boolean {
    return a && b && a.id === b.id;
  }

  pesquisar(form, pageSearch = false) {
    if (!pageSearch) {
      this.form.controls.page.setValue(0);
    }
    this.regras = [];
    this.totalRegistros = 0;

    this.subscriptions.add(
      this.service
        .search(form, this.pageSize, this.composta)
        .pipe(indicate(this.loading$))
        .subscribe(
          res => {
            this.showExecutar = true;
            if (res.metadata.totalElements > 0) {
              if (res.metadata.size === 0) {
                this.paginationTotalPage = 1;
              } else {
                this.paginationTotalPage = Math.ceil(
                  res.metadata.totalElements / res.metadata.size
                );
              }
              this.totalRegistros = res.metadata.totalElements;
              this.regras = res.content.map((e) =>
                Object.assign(new Regra(), e)
              );

              this.form.get("page").setValue(res.metadata.number);
            } else {
              this.paginationTotalPage = 1;
            }
            this.changeDetectorRef.detectChanges();
          },
          err => this.messageService.erro(err.error.message)
        )
    );
  }

  receiverPage(value) {
    this.currentPage.next(value);
    this.form.controls.page.setValue(value - 1);
    this.pesquisar(this.form.value, true);
  }

  updateOrder($event: any) {
    let sortComparator;
    switch ($event.field) {
      case "REGRA":
        sortComparator = (a: Regra, b: Regra) => a.nome.localeCompare(b.nome);
        break;
      case "FUNCAO":
        sortComparator = (a: Regra, b: Regra) =>
          a.funcao.localeCompare(b.funcao);
        break;
      case "INICIO_VIGENCIA":
        sortComparator = (a: Regra, b: Regra) =>
          a.inicioVigencia.localeCompare(b.inicioVigencia);
        break;
      case "FIM_VIGENCIA":
        sortComparator = (a: Regra, b: Regra) =>
          a.fimVigencia.localeCompare(b.fimVigencia);
        break;
    }

    this.regras.sort(sortComparator);
    if (!$event.direction) {
      this.regras.reverse();
    }
    this.updatePageSize(this.pageSize);
  }

  updateDatasource() {
    this.allElements = this.regras;
    this.totalElements = this.regras.length;
    this.updatePageSize(this.pageSize);
  }

  updatePageSize(pageSize: number) {
    this.pageSize = pageSize;
    this.totalPages = this.totalElements / pageSize;
    this.paginatedDataSource = this.breakIntoChunks(
      this.allElements,
      this.pageSize
    );
    this.dataSource = this.paginatedDataSource[0];
    this.paginationTotalPage = 1;

    this.receiverPage(1);
    // precisei setar direto no componente,  o model não atualiza quando muda o total de paginas
  }

  save() {
    let _regra: Regra = new Regra(this.regraEdicao);

    _regra.inicioVigencia = moment(_regra.inicioVigencia, "DD/MM/YYYY").format("YYYY-MM-DD");
    _regra.fimVigencia = moment(_regra.fimVigencia, "DD/MM/YYYY").format("YYYY-MM-DD");
    let observable;
    if (this.composta) {
      observable = this.service.alterarRegraComposta(_regra);
    } else {
      observable = this.service.alterarRegraSimples(_regra);
    }
    observable.subscribe(
      _ => {
        this.regras = this.regras
          .map(a =>
            this.regraIsEqual(a, new Regra(this.regraOriginal))
              ? new Regra(this.regraEdicao)
              : a
          );
        this.messageService.textoLight("Regra alterada com sucesso.");
      },
      err => {
        this.messageService.erro(err);
      },
      () => {
        this.setModoEdicao(null);
      }
    )
  }

  private breakIntoChunks(array, chunk) {
    const temparray = [];
    for (let i = 0, j = 0; i < array.length; j++, i += chunk) {
      temparray[j] = array.slice(i, i + chunk);
    }
    return temparray;
  }

  deletarRegra(evento) {
    console.log(evento);
  }

  openEditDialog(regra: Regra, isConsulta: boolean, composta = false) {
    const dialogRef = this.dialog.open(ModalEditarRegraDialogComponent, {
      data: {regra, isConsulta, composta},
      minWidth: "80vw",
      maxWidth: "80vw",
      maxHeight: "99vh",
      autoFocus: false,
    });

    dialogRef.componentInstance.editado.subscribe(() => this.pesquisar(this.form.value));
  }

  openDeleteDialog(regra: Regra) {
    const dialogRef = this.dialog.open(ModalDeletarRegraDialogComponent, {
      data: regra,
      width: "800px",
    });

    dialogRef.componentInstance.deletado.subscribe(() => this.pesquisar(this.form.value));
  }

  onChangeTotalPagina(e) {
    this.updatePageSize(e);
  }


  exportarPdf() {
    this.subscriptions.add(
      this.service.exportPdf(this.form.value, this.composta).pipe(indicate(this.loadingExport$)).subscribe(data => {
        BrowserSupport.savePDF(data);
      }, err => this.messageService.erro(err.error.message)));
  }

  exportarXls() {
    this.subscriptions.add(
      this.service.exportXlsx(this.form.value, this.composta).pipe(indicate(this.loadingExport$)).subscribe(data => {
        BrowserSupport.saveXlsx(data);
      }, err => this.messageService.erro(err.error.message)));
  }
}
